export default "__VITE_ASSET__CAPS_los__";